const baseURL = process.env.REACT_APP_BASE_URL;
// const baseURL = "http://127.0.0.1:3333/api/v1"

export const vendorAppUrl = process.env.REACT_APP_VENDOR_APP_URL;

export default baseURL;
